import React, { useEffect, useMemo, useRef, useState } from "react";
import { SideSVG } from "../../../common";
import { ReactComponent as nameWithPhone } from "../../../../assets/images/companyIcons/mobile-in-hand.svg";
import { ReactComponent as ArrowLeft } from "../../../../assets/icons/arrowleft.svg";
import { ReactComponent as ArrowRight } from "../../../../assets/icons/arrowright.svg";
import { ReactComponent as RemoveX } from "../../../../assets/icons/remove-x.svg";

import Logo from "../../Logo";
import SubIndustry from "./industriesOption/SubIndustry";
import { setIndustryDetails } from "../../../../store/claim/claimSlice";
import { useDispatch, useSelector } from "react-redux";
import Select, { components } from "react-select";
import { SubIndustriesValue } from "./industriesOption/IndustriesValue";
import "./industry.css"
import { ReactComponent as PurpleCheck } from '../../../../assets/icons/purpleCheck.svg'
import CommonTooltip from "../../../common/Tooltip";
import { addEllipsisAfter50Words, customReactSelectStyles } from "../../../../utils/Helper";
import Arrow from "../../../common/Arrow";
import { useGetSubIndustriesDataQuery } from "../../../../store/Company/companyApiSlice";
import IndustryMultiSelect from "../../../common/IndustryMultiSelect";


const Dropdown = ({ onNext, onPrev }) => {
  const { token } = useSelector((state) => state.auth);
  const [fetchedSubIndustried, setFetchedSubIndustries] = useState([]);
  const { data: subIndustries, isLoading, error } = useGetSubIndustriesDataQuery({ token });
  // Custom Option to show tick and bg color
  // const CustomOption = (props) => {
  //   const { isSelected, isFocused, innerRef, innerProps, data } = props;
  //   return (
  //     <div
  //       ref={innerRef}
  //       {...innerProps}
  //       className={`custom-option ${isSelected ? "selected" : ""} ${isFocused ? "focused" : ""}`}
  //       style={{
  //         display: "flex",
  //         justifyContent: "space-between",
  //         alignItems: "center",
  //         padding: "8px 12px",
  //       }}
  //     >
  //       <span className="text-left w-[85%]">{data.label}</span>
  //       {isSelected && <PurpleCheck />}
  //     </div>
  //   );
  // };
  // Override MultiValue so it doesn't render selected values inside input
  // const CustomMultiValue = () => null;
  const dispatch = useDispatch();
  const { industryDetails } = useSelector((state) => state.claims);
  const selectRef = useRef(null);
  const scrollRef = useRef(null);
  useEffect(() => {
    const options = subIndustries?.data ? subIndustries?.data?.map((industry) => {
      return { label: industry.sub_industry, value: industry.id };
    }) : [];
    setFetchedSubIndustries(options);
  }, [subIndustries])
  const [searchInput, setSearchInput] = useState("");
  const [showScrollButtons, setShowScrollButtons] = useState(false);
  const [canScrollUp, setCanScrollUp] = useState(false);
  const [canScrollDown, setCanScrollDown] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);

  useMemo(() => {
    setSelectedOptions(industryDetails)
  }, [industryDetails])






  const scrollSelectedBox = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 40; // px
      scrollRef.current.scrollBy({
        top: direction === "up" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (el) {
      const canScrollDown = el.scrollTop + el.clientHeight < el.scrollHeight;
      const canScrollUp = el.scrollTop > 0;

      setCanScrollDown(canScrollDown);
      setCanScrollUp(canScrollUp);
      setShowScrollButtons(canScrollDown || canScrollUp);
    }
  }, [selectedOptions]);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [selectedOptions]);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const handleScroll = () => {
      const canScrollDown = el.scrollTop + el.clientHeight < el.scrollHeight;
      const canScrollUp = el.scrollTop > 0;

      setCanScrollDown(canScrollDown);
      setCanScrollUp(canScrollUp);
    };

    el.addEventListener("scroll", handleScroll);
    return () => el.removeEventListener("scroll", handleScroll);
  }, [selectedOptions]);



  const handleTagClick = (label) => {
    setSearchInput(label); // prefill search box
    if (selectRef.current) {
      selectRef.current.focus(); // focus the input box
    }
  };

  const handleChange = (selected) => {
    setSelectedOptions(selected || []);
  };

  const handleRemove = (value) => {
    setSelectedOptions((prev) => prev.filter((opt) => opt.value !== value));
  };

  const handleIndustrySave = async (e) => {
    e.preventDefault();
    dispatch(setIndustryDetails(selectedOptions))
    onNext();
  }

  return (
    <section className="relative px-4 sm:px-0 py-20 lg:py-0 overflow-hidden">
      <div className="px-0 mx-auto">
        <div className="mx-auto relative">
          <Logo />
          <div className="flex flex-wrap -mx-4 xl:items-center items-center">
            <div className="flex-flex1 w-full lg:w-1/2 xl:w-3/5 px-4 order-last lg:order-first">
              <div class="max-w-md py-20 mx-auto" >
                <h3 className="font-heading text-f24 sm:text-f30 text-primary font-bold mb-4 text-center punitpunit" >
                  Choose your industry classification
                </h3>
                <p className="text-f16 sm:text-f18 text-secondarytwo " >
                  Select the appropriate classifications to ensure an accurate representation of your company in our directory.
                </p>



                <IndustryMultiSelect
                  options={fetchedSubIndustried}
                  selectedOptions={selectedOptions}
                  onChange={(updated) => setSelectedOptions(updated)}
                  onPrev={onPrev}
                  onSave={(data) => {
                    dispatch(setIndustryDetails(data));
                    onNext();
                  }}
                />



              </div>
            </div>

            <SideSVG SVG={nameWithPhone} positions="bottom-0  left-[-25%]" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Dropdown;
